<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M20.0484 6.3516c.225.22503.3513.5302.3513.8484 0 .3182-.1263.62337-.3513.8484l-9.6 9.6c-.225.225-.5302.3513-.8484.3513-.3182 0-.62337-.1263-.8484-.3513l-4.8-4.8c-.21859-.2263-.33954-.5294-.33681-.8441.00274-.3146.12894-.6156.35143-.8381.22249-.2225.52346-.3487.8381-.3514.31463-.0027.61776.1182.84408.3368L9.6 15.1032l8.7516-8.7516c.225-.22496.5302-.35134.8484-.35134.3182 0 .6234.12638.8484.35134Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M19.7071 6.29289c.3905.39053.3905 1.02369 0 1.41422L9.70711 17.7071c-.39053.3905-1.02369.3905-1.41422 0l-4-4c-.39052-.3905-.39052-1.0237 0-1.4142.39053-.3905 1.02369-.3905 1.41422 0L9 15.5858l9.2929-9.29291c.3905-.39052 1.0237-.39052 1.4142 0Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
